export enum ProgramType {  
  SDoHReferrals = 'sdoh',
  WCCAdmissions = 'wcc'
}
